<template>
  <h3>Просмотр ФСД</h3>
</template>

<script>
export default {
  name: 'DataCollectionFormView',
}
</script>
